module.exports = __webpack_public_path__ + "static/media/25532682854_f54ee7ac2d_o-1.e6ee170f.jpg";